import { APIClient } from "./api_helper";

const api = new APIClient();

export const getSettingsApi = () => {
  return api.get("/api/admin/settings"); // public endpoint, no auth needed
};